import { render } from "./AdminCanalNavIntegration.vue?vue&type=template&id=5dc037ec&scoped=true"
import script from "./AdminCanalNavIntegration.vue?vue&type=script&lang=js"
export * from "./AdminCanalNavIntegration.vue?vue&type=script&lang=js"

import "./AdminCanalNavIntegration.vue?vue&type=style&index=0&id=5dc037ec&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5dc037ec"]])

export default __exports__